import React, { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import Header from "../../SubComponents/Header";
import ChiefBlocks from "../../SubComponents/SubStructureComponents/chief_blocks";
import ChiefExecutive from "../../SubComponents/SubStructureComponents/сhief_executive";
import Footer from "../../SubComponents/footer";
import "./style.css";
import Video from "../../assets/img/welcome.mp4";
import { API_BASE_URL } from "../../config/config";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";

const Sidebar = ({ selectedDepartmentId, onDepartmentClick }) => {
  const { i18n } = useTranslation();
  const [departments, setDepartments] = useState([]);

  const ORDER = [16, 32, 34, 33, 26, 28, 27];

  useEffect(() => {
    const langCode = i18n.language;
    axios
      .get(`${API_BASE_URL}/api/departaments?lang=${langCode}`, {
        headers: { accept: "text/plain", "api-version": "1.0" },
      })
      .then((response) => {
        const departmentsData = response.data;

        const filtered = departmentsData.filter((d) => ORDER.includes(d.id));

        const sorted = filtered.sort(
          (a, b) => ORDER.indexOf(a.id) - ORDER.indexOf(b.id),
        );

        setDepartments(sorted);

        if (sorted.length > 0 && !selectedDepartmentId) {
          onDepartmentClick(sorted[0].id);
        }
      })
      .catch((error) => console.error(error));
  }, [i18n.language]);

  return (
    <div className="structure-sidebar">
      <ul className="sidebar-nav departments-nav">
        {departments.map((department) => (
          <li
            key={department.id}
            className={`sidebar-item ${
              String(selectedDepartmentId) === String(department.id)
                ? "active"
                : ""
            }`}
          >
            <button
              onClick={() => onDepartmentClick(department.id)}
              className="sidebar-department-button"
            >
              {department.name.toUpperCase()}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

const StructureMain = () => {
  const { t } = useTranslation();
  const [selectedDepartmentId, setSelectedDepartmentId] = useState(
    localStorage.getItem("selectedDepartmentId"),
  );

  const handleDepartmentClick = (id) => {
    const stringId = String(id);
    setSelectedDepartmentId(stringId);
    localStorage.setItem("selectedDepartmentId", stringId);
  };

  return (
    <>
      <div className="position-relative white-text" style={{ height: "230px" }}>
        <video
          autoPlay
          loop
          muted
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        >
          <source src={Video} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
          }}
        ></div>
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            zIndex: 5000,
          }}
        >
          <Header />
        </div>
      </div>

      <div className="structure-content-wrapper">
        <Container className="py-5">
          <Row>
            <h4 className="pb-1 card-title text-start">{t("Structure")}</h4>
          </Row>
        </Container>
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-4">
              <Sidebar
                selectedDepartmentId={selectedDepartmentId}
                onDepartmentClick={handleDepartmentClick}
              />
            </div>

            <div className="col-lg-9 col-md-8">
              <ChiefExecutive departmentId={selectedDepartmentId} />
              <ChiefBlocks departmentId={selectedDepartmentId} />
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default StructureMain;
